const auth_status = {
    page_title: 'Статус аутентификации',
    title: 'Статус аутентификации',
    description: 'Проверьте статус аутентификации.',
};
export default Object.freeze(auth_status);
